<template>
  <span>
    <span v-if="value">
      <template v-if="value.toLowerCase() == 'updating'">
        <img src="/img/Spinner-1s-30px.gif" />
      </template>
      <template v-else>
        <span :title="value">
          <v-icon
            v-if="!disabled"
            :size="iconSize"
            :color="ecuStateColors[value.toLowerCase()]"
          >
            air
          </v-icon>
          <v-icon
            v-else
            :size="iconSize"
            color="rgb(192, 192, 192)"
          >
            air
          </v-icon>
        </span>
      </template>
    </span>
  </span>
</template>

<script>
import { ecuStateColors } from '@/services/batchActions'
export default {
  name: "EcuState",
  props: ["value", "onclick", "iconSize", "disabled"],
  components: {},
  beforeMount() {
    /*
    if (this.$vuetify.theme.isDark) {
      this.ecuStateColors.off = "gray";
    }
    */
  },
  mounted() {},
  data() {
    return {
      ecuStateColors: ecuStateColors
    };
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
